import React from 'react'

export default function StartAssociationsSection() {
    return (
        <>
            <section className="associations-section" id="associations-section">
                <div className="row ">
                    <div className="container">
                        <div className="associations-wrap">
                            <div className="title wow zoomIn">
                                <h2>Why Associations <span className="red">Love Snapshot Videos</span></h2>
                            </div>
                            <div className="associations-image-content-wrap">
                                <div className="associations-colum first ">
                                    <div className="box box-red wow fadeInLeft">
                                        <div className="box-image ">
                                            <img src="./images/associations-effort-less.png" />
                                        </div>
                                        <div className="box-text">
                                            <h3>Effortless, Turnkey Production</h3>
                                            <p>Leave the heavy lifting to Association Studios—we make creating professional videos simple and stress-free.</p>
                                        </div>
                                    </div>
                                    <div className="box box-gray wow fadeInRight">
                                        <div className="box-image">
                                            <img src="./images/associations-proven-member.png" />
                                        </div>
                                        <div className="box-text">
                                            <h3>Proven Member
                                                Engagement</h3>
                                            <p>Deliver updates that captivate and connect, strengthening relationships with your members and industry.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="associations-colum second wow zoomIn">
                                    <div className="box box-black">
                                        <div className="box-image">
                                            <img src="./images/associations-versatile.png" />
                                        </div>
                                        <div className="box-text">
                                            <h3>Versatile Content for
                                                Every Platform</h3>
                                            <p>Perfectly tailored for newsletters, websites, and social media, Snapshot Videos keep your audience engaged wherever they are.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="last-text wow fadeInRight">
                                <p>Discover how Snapshot Videos can transform your communications today!</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
